import { createContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { API_BASE_URL } from "../services/api";
import { normalizeAdminUser } from "../utils/adminPermissions";

export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [usuario, setUsuario] = useState({});
  const [autenticado, setAutenticado] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  // ================= LOGIN =================
  async function fazerLogin(username, password) {
    setLoading(true);

    try {
      const res = await axios.post(
        `${API_BASE_URL}/login`,
        { username, password }
      );

      const token = res.data.token;

      if (!token) {
        setErrorMessage("Credenciais inválidas");
        return;
      }

      // 🔥 salvar token
      localStorage.setItem("token", token);

      // 🔥 CONFIGURAR HEADER GLOBAL
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

      // 🔥 decode
      const dadosUsuario = normalizeAdminUser(jwtDecode(token));

      setUser(dadosUsuario.name);
      setUsuario(dadosUsuario);
      setAutenticado(true);

      // 🔥 controle por tipo
      if (dadosUsuario.tipoUsuario === "super") {
        setIsAdmin(true);
        navigate("/super");
      } else if (
        dadosUsuario.tipoUsuario === "admin" ||
        dadosUsuario.tipoUsuario === "admin_pleno"
      ) {
        if (dadosUsuario.estado === "ativo" || dadosUsuario.estado === null) {
          setIsAdmin(true);
          navigate("/admin");
        } else {
          setErrorMessage("Conta desativada");
        }
      } else {
        setIsAdmin(false);
        navigate("/home");
      }

    } catch (error) {
      setErrorMessage("Usuário ou senha inválidos");
    } finally {
      setLoading(false);
    }
  }

  // ================= VERIFICAR LOGIN =================
  function verificarLogin() {
    try {
      const token = localStorage.getItem("token");

      if (!token) {
        setAutenticado(false);
        return;
      }

      // 🔥 CONFIGURA HEADER AO RECARREGAR
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

      const dadosUsuario = normalizeAdminUser(jwtDecode(token));

      setUser(dadosUsuario.name);
      setUsuario(dadosUsuario);
      setAutenticado(true);

      if (
        dadosUsuario.tipoUsuario === "admin" ||
        dadosUsuario.tipoUsuario === "admin_pleno" ||
        dadosUsuario.tipoUsuario === "super"
      ) {
        setIsAdmin(true);
      } else {
        setIsAdmin(false);
      }

    } catch (erro) {
      console.log(erro);
      logout();
    }
  }

  // ================= LOGOUT =================
  function logout() {
    localStorage.removeItem("token");

    // 🔥 REMOVE HEADER
    delete axios.defaults.headers.common["Authorization"];

    setUser(null);
    setUsuario({});
    setAutenticado(false);
    setIsAdmin(false);

    navigate("/login");
  }

  // 🔥 AUTO LOGIN
  useEffect(() => {
    verificarLogin();
  }, []);

  return (
    <AuthContext.Provider
      value={{
        user,
        usuario, // 🔥 contém pop
        autenticado,
        isAdmin,
        loading,
        errorMessage,
        setErrorMessage,
        fazerLogin,
        verificarLogin,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
